<template>
	<div></div>
</template>

<script>
    import {mapMutations} from "vuex";
    import { getRecordByPlateNo, order } from "../../api/coupon/platePay";
    export default {
        name: "orderInfo",
		mounted () {
            if (this.$route.query.plateno && this.$route.query.parkrecId && this.$route.query.outDoor){//推送消息入口进入
                let form = {
                    plateno:this.$route.query.plateno,
                    id:this.$route.query.parkrecId,
                    outDoor:this.$route.query.outDoor
                };
                getRecordByPlateNo(form).then(res =>{
                    if(res.code === 200){
                        this.setParkrec(res.data);
                        this.setParkingId(res.data.parkinglotId);
                        this.setAreaId(res.data.areaId);
                        this.setCouponFee(parseFloat(res.data.parkCoupon || 0).toFixed(2));
                        if (res.data.unpaidMoney > 0){//支付未完成
                            let orderForm = {
                                outDoor:this.$route.query.outDoor,
                                totalPrice: parseFloat(res.data.unpaidMoney).toFixed(2),
                                parkRec: this.$route.query.parkrecId,
                                parkinglotId: res.data.parkinglotId,
                                goodsType: 2,//2为出场支付
                                closed: 0,
                                paymentPlatform: this.checkBrowser.id,
                                areaId: res.data.areaId,
                                plateno: this.$route.query.plateno
                            };
                            order(orderForm).then(req =>{
                                if (req.code === 200 ){
                                    this.setOrderInfo(req.data);
                                    this.$router.push({name: "InsideOrder", params: {isEntry: true}});
                                }
                            })
						}else {
                            this.$router.push({name: "InsideOrder", params: {isEntry: true}});
						}
                    }
                })
            }
		},
		methods: {
            ...mapMutations({
                setCouponFee: "SET_COUPONFEE",
                setOrderInfo: "SET_ORDER_INFO",
                setParkrec: "SET_PARKREC",
                setParkingId: "SET_PARKINGLOTID",
                setAreaId: 'SET_AREA_ID',
            })
        }
    }
</script>

<style scoped>

</style>
